export const CATEGORIES = {
    BEVERAGE: { label: 'Beverage', value: 'beverage' },
    CAKE: { label: 'Cake', value: 'cake' },
    PASTRY: { label: 'Pastry', value: 'pastry' },
    COOKIE: { label: 'Cookie', value: 'cookie' }
};